import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// components
import Logo from './components/Logo.vue'
Vue.component('logo', Logo)

import ApiImage from './components/ApiImage.vue'
Vue.component('api-image', ApiImage)

import Loading from './components/Loading.vue'
Vue.component('loading', Loading)

import Quality from './components/Quality.vue'
Vue.component('quality', Quality)

import Password from './components/Password.vue'
Vue.component('password', Password)

import Alert from './components/Alert.vue'
Vue.component('alert', Alert)

import VueSelect from './components/VueSelect.vue'
Vue.component('vue-select', VueSelect)

import InputQuality from './components/InputQuality.vue'
Vue.component('input-quality', InputQuality)

import Pagination from 'vue-pagination-2'
Vue.component('pagination', Pagination);

import Modal from './components/Modal.vue'
Vue.component('modal', Modal)

import AreYouSure from './components/AreYouSure.vue'
Vue.component('are-you-sure', AreYouSure)

import ImagePicker from './components/ImagePicker.vue'
Vue.component('image-picker', ImagePicker)

// plugins
import AppStorage from './plugins/storage'
Vue.use(AppStorage)

import ApiResponse from './plugins/api-response'
Vue.use(ApiResponse)

import Toast from "vue-toastification";
Vue.use(Toast, {});

import './theme'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
